import CONSTANTS from '../../constants';

export const SENTRY_CONFIG = {
  dsn: CONSTANTS.ENV.SENTRY_DSN,
  environment: CONSTANTS.ENV.SENTRY_ENV,
};
